import { useEffect, useState } from 'react';

import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../components/BoxConteudo';
import CustomCol from '../../../components/CustomCol';
import { CustomSwal } from '../../../components/CustomFeedback/CustomSwal';
import CustomInputDate from '../../../components/CustomInputs/CustomInputDate';
import CustomInputInt from '../../../components/CustomInputs/CustomInputInt';
import CustomInputMask from '../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../components/CustomRow';
import CustomSelect from '../../../components/CustomSelects/CustomSelect';
import Log from '../../../components/Log/Log';
import WorkspaceBotoesNew from '../../../components/WorkspaceBotoes/indexNew';
import WorkspaceFicha from '../../../components/WorkspaceFicha';
import { getUser } from '../../../modules/contexts/Auth/RequireAuth';
import { Interface } from '../../../modules/types/interface';
import {
  getInterfaces,
  getUsuarioVinculoById,
} from '../../../services/usuario/usuarioVinculoService';
import {
  formataNomeMeioSiglas,
  getDominioOptions,
  transformarEnumOptionValueEmLabel,
} from '../../../utils/functions';
import { handleSave } from '../../../utils/handleSave';
import { swal, swalErro } from '../../../utils/swal';

interface Props {
  fichaID: number;
  idVinculo?: number;
  onRefreshData: () => void;
}

const FormVinculacaoUsuario: React.FC<Props> = ({
  fichaID,
  idVinculo,
  onRefreshData,
}) => {
  const initialFormData = {
    id: idVinculo || 0,
    usuarioId: fichaID,
    papelId: '',
    nuInterface: '',
    nuSolicitacao: '',
    status: '',
    statusLabel: '',
    numeroSeiContrato: '',
    numeroDocumentoSEI: '',
    interfaceVinculo: '',
    interfaceId: '',
    dataInicio: new Date().toISOString().split('T')[0],
    dataTermino: '',
    observacao: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  let logs = {};
  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nuEdicao: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });
  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  const [optionsStatus, setOptionsStatus] = useState<any[]>([]);
  const [optionsTipoVinculacao, setoptionsTipoVinculacao] = useState<any[]>([]);
  const [optionsInterface, setOptionsInterface] = useState<any[]>([]);
  const [optionsPapelUsuario, setOptionsPapelUsuario] = useState<any[]>([]);
  const [optionsInterfaceVinculo, setOptionsInterfaceVinculo] = useState<
    Interface[]
  >([]);
  const interfaceLabel = transformarEnumOptionValueEmLabel(
    Number(formData.nuInterface),
    optionsInterface,
  );
  const statusLabel = transformarEnumOptionValueEmLabel(
    Number(formData.status),
    optionsStatus,
  );
  const user = getUser();
  const userID = user.sub;

  useEffect(() => {
    const fetchOptions = async () => {
      const sel = getDominioOptions(12);
      setOptionsStatus(sel);

      const selInterface = getDominioOptions(97);
      setOptionsInterface(selInterface);

      const selPapelUsuario = getDominioOptions(101);
      setOptionsPapelUsuario(selPapelUsuario);
    };
    fetchOptions();
  }, []);

  const handleChange = async (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;

    if (name === 'nuInterface' && Number(value) === 98) {
      setFormData((prevState) => ({
        ...prevState,
        numeroSeiContrato: '',
        numeroDocumentoSEI: '',
      }));
    }

    if (name === 'status') {
      const statusOption = optionsStatus.find(
        (option) => String(option.value) === String(value),
      );
      const statusLabel = statusOption ? statusOption.label : '';
      setFormData((prevState) => ({
        ...prevState,
        status: value,
        statusLabel: statusLabel,
      }));
    } else if (name === 'nuInterface') {
      const interfaceLabel = transformarEnumOptionValueEmLabel(
        Number(value),
        optionsInterface,
      );
      const response = (await getInterfaces(interfaceLabel)) as any;
      if (response && response.registros) {
        setOptionsInterfaceVinculo([
          { value: 0, label: 'Não informado' },
          ...response.registros,
        ]);
      } else {
        setOptionsInterfaceVinculo([]);
      }
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        interfaceVinculo: '',
        interfaceId: '',
      }));
    } else if (name === 'interfaceVinculo') {
      setFormData((prevState) => ({
        ...prevState,
        interfaceVinculo: value,
        interfaceId: value,
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };
  const ajustaForm = (form: any) => {
    const adjustedForm = {
      ...form,
      interface: interfaceLabel,
    };
    return adjustedForm;
  };

  const camposObrigatorios = {
    status: 'Status',
    dataInicio: 'Data Início',
    nuInterface: 'Interface',
    papelId: 'Papel Usuário',
    interfaceVinculo: 'Setor DAF, SES ou Fornecedor',
    ...(statusLabel === 'Inativo' ? { dataTermino: 'Data Término' } : {}),
    ...(interfaceLabel === 'Fornecedor'
      ? { numeroSeiContrato: 'Nº Processo SEI' }
      : {}),
    ...(interfaceLabel === 'Fornecedor'
      ? { numeroDocumentoSEI: 'Documento SEI' }
      : {}),
  };
  const camposAjustar = {
    number: [
      'status',
      'nuSolicitacao',
      'nuInterface',
      'papelId',
      'interfaceVinculo',
      'interfaceId',
    ],
    string: ['dataInicio', 'dataTermino', 'observacao'],
  };

  const fetchData = async (id: string | number): Promise<void> => {
    try {
      const data = await getUsuarioVinculoById(Number(id));
      if (data.status) {
        if (data.status.nome === 'Inativo') {
          setIsFormDisabled(true);
        }
      }
      setLogData(data);

      setFormData({
        ...data,
        dataInicio: data.dataInicio
          ? new Date(data.dataInicio).toISOString().split('T')[0]
          : '',
        dataTermino: data.dataTermino
          ? new Date(data.dataTermino).toISOString().split('T')[0]
          : '',
        nuInterface: data.interface.id,
        nuSolicitacao: data.nuSolicitacao.value,
        status: data.status && data.status.id ? data.status.id : 0,
        statusLabel: data.status ? data.status.nome : '',
        papelId: data.papel.id,
      });
      setOptionsInterfaceVinculo([
        {
          value: data.interfaceVinculo.value,
          label: data.interfaceVinculo.label,
        },
      ]);
      setoptionsTipoVinculacao([
        {
          value: data.nuSolicitacao.value,
          label: data.nuSolicitacao.label,
        },
      ]);
      onRefreshData();
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao buscar dados do registro', error);
      swalErro('Erro ao carregar os dados para edição.');
    }
  };

  useEffect(() => {
    if (idVinculo && idVinculo !== 0 && optionsStatus.length > 0) {
      fetchData(idVinculo);
    } else if (!idVinculo || idVinculo === 0) {
      setFormData(initialFormData);
      setIsFormDisabled(false);
      setoptionsTipoVinculacao([
        {
          value: 0,
          label: 'Criado pelo Admin',
        },
      ]);
    }
  }, [idVinculo, optionsStatus]);

  const salvar = async (dados?: any) => {
    try {
      const formToSave = dados && dados.usuarioId ? dados : formData;
      const adjustedForm = ajustaForm(formToSave);
      const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/';
      };
      handleSave(
        adjustedForm,
        camposObrigatorios,
        camposAjustar,
        'usuario-vinculos',
        '',
        String(userID) !== String(fichaID) ||
          formToSave.statusLabel !== 'Inativo'
          ? fetchData
          : handleLogout,
        false,
      );
    } catch (error) {
      console.error('Erro ao salvar os dados', error);
    }
  };

  const handleAprovar = () => {
    CustomSwal.show({
      title: 'Atenção',
      html: 'Deseja realmente aprovar este vínculo?',
      type: 'warning',
      confirmText: 'Sim, aprovar',
      confirmButtonColor: '#2e7d32',
      onConfirm: async () => {
        try {
          const statusAtivo = optionsStatus.find((op) => op.label === 'Ativo');
          if (statusAtivo) {
            const novosDados = {
              ...formData,
              status: statusAtivo.value,
              statusLabel: 'Ativo',
            };
            salvar(novosDados);
          }
        } catch (error) {
          console.error('Erro ao aprovar vínculo:', error);
          swal('error', 'Erro', 'Não foi possível aprovar o vínculo.');
        }
      },
    });
  };
  // Rejeitar
  const handleRejeitar = () => {
    CustomSwal.show({
      title: 'Atenção',
      html: `Deseja realmente ${formData.statusLabel === 'Ativo' ? 'desvincular' : 'rejeitar'} este vínculo?`,
      type: 'warning',
      confirmText: `Sim, ${formData.statusLabel === 'Ativo' ? 'desvincular' : 'rejeitar'}`,
      onConfirm: async () => {
        try {
          const statusInativo = optionsStatus.find(
            (op) => op.label === 'Inativo',
          );
          if (statusInativo) {
            const novosDados = {
              ...formData,
              status: statusInativo.value,
              statusLabel: 'Inativo',
              dataTermino: new Date().toISOString().split('T')[0],
            };
            salvar(novosDados);
          }
        } catch (error) {
          console.error('Erro ao rejeitar vínculo:', error);
          swal('error', 'Erro', 'Não foi possível rejeitar o vínculo.');
        }
      },
    });
  };

  const isPendente = formData.id !== 0 && !formData.status;
  const isAtivo = formData.statusLabel === 'Ativo' && formData.id !== 0;
  const isInativo = formData.statusLabel === 'Inativo' && formData.id !== 0;
  const isNovo = formData.id === 0;

  if (formData.id && formData.id !== 0) {
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nuEdicao,
    };
  }
  // const today = new Date().toISOString().split('T')[0];
  return (
    <WorkspaceFicha>
      {formData.id !== 0 && (
        <Log
          {...logs}
          entity="TB_VINCULO"
          id={formData.id}
          refreshTriggerLog={refreshTriggerLog}
        />
      )}
      <BoxConteudo boxTitulo="Identificação da Vinculação">
        <CustomRow style={{ marginTop: '10px' }}>
          <CustomCol width="200px">
            <CustomSelect
              name="status"
              value={formData.status}
              options={optionsStatus}
              title="Status"
              onChange={handleChange}
              required
              disabled={isFormDisabled || !isNovo}
            />
          </CustomCol>
          <CustomCol width="200px">
            <CustomInputDate
              name="dataInicio"
              value={formData.dataInicio}
              onChange={handleChange}
              title="Data Início"
              readOnly={true}
            />
          </CustomCol>
          <CustomCol width="200px">
            <CustomInputDate
              name="dataTermino"
              value={formData.dataTermino}
              readOnly={formData.statusLabel !== 'Inativo' || isFormDisabled}
              required={formData.statusLabel === 'Inativo'}
              onChange={handleChange}
              title="Data Término"
              minDate={
                formData.dataInicio ? new Date(formData.dataInicio) : undefined
              }
            />
          </CustomCol>
          <CustomCol width="250px">
            <CustomSelect
              name="nuSolicitacao"
              value={formData.nuSolicitacao}
              options={optionsTipoVinculacao}
              title="Tipo de Operação"
              onChange={handleChange}
              disabled
              required
            />
          </CustomCol>
          <CustomCol></CustomCol>
        </CustomRow>
        <CustomRow>
          <CustomCol width="200px">
            <CustomSelect
              name="nuInterface"
              value={formData.nuInterface}
              options={optionsInterface}
              title="Interface"
              onChange={handleChange}
              disabled={!!formData.id}
              required
            />
          </CustomCol>
          <CustomCol width="200px">
            <CustomSelect
              name="papelId"
              value={formData.papelId}
              options={optionsPapelUsuario}
              title="Papel Usuário"
              onChange={handleChange}
              disabled={Number(formData.status) > 0 && formData.id > 0}
              required
            />
          </CustomCol>
          <CustomCol width="250px">
            <CustomInputMask
              id="numeroSeiContrato"
              name="numeroSeiContrato"
              value={formData.numeroSeiContrato}
              title="Nº Processo SEI"
              mask="99999.999999/9999-99"
              onChange={handleChange}
              readOnly={interfaceLabel !== 'Fornecedor' || !!formData.id}
              required={interfaceLabel === 'Fornecedor'}
              placeholder={
                interfaceLabel === 'Fornecedor'
                  ? ''
                  : formData.numeroSeiContrato || 'Não se aplica'
              }
            />
          </CustomCol>
          <CustomCol width="250px">
            <CustomInputText
              id="numeroDocumentoSEI"
              name="numeroDocumentoSEI"
              value={formData.numeroDocumentoSEI}
              title="Documento SEI"
              onChange={handleChange}
              readOnly={interfaceLabel !== 'Fornecedor' || !!formData.id}
              required={interfaceLabel === 'Fornecedor'}
              placeholder={
                interfaceLabel === 'Fornecedor'
                  ? ''
                  : formData.numeroDocumentoSEI || 'Não se aplica'
              }
            />
          </CustomCol>
          <CustomCol> </CustomCol>
        </CustomRow>
        <CustomRow>
          <CustomCol>
            <CustomSelect
              name="interfaceVinculo"
              value={formData.interfaceVinculo}
              options={optionsInterfaceVinculo}
              title="Setor DAF, SES ou Fornecedor"
              required
              onChange={handleChange}
              disabled={!!formData.id}
            />
          </CustomCol>
          <CustomCol width="150px">
            <CustomInputInt
              name="interfaceId"
              value={formData.interfaceId}
              title=" ID Setor/SES/Forn."
              readOnly
            />
          </CustomCol>
        </CustomRow>
        <CustomRow>
          <CustomCol width="100%" height="100%">
            <CustomInputText
              id="observacao"
              name="observacao"
              value={formData.observacao}
              title="Observações"
              type="textArea"
              onChange={handleChange}
              rows={5}
              readOnly={isFormDisabled}
            />
          </CustomCol>
        </CustomRow>
        <BarraInferiorBotoes>
          {isPendente && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                gap: '10px',
                justifyContent: 'space-between',
              }}
            >
              <WorkspaceBotoesNew
                label="Aprovar"
                cor="#2e7d32"
                tipo="save"
                onClick={handleAprovar}
              />
              <WorkspaceBotoesNew
                label="Rejeitar"
                cor="#d32f2f"
                tipo="save"
                onClick={handleRejeitar}
              />
            </div>
          )}
          {isAtivo && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              <WorkspaceBotoesNew
                label="Desvincular"
                tipo="cancel"
                onClick={handleRejeitar}
                cor="#d32f2f"
              />
              <WorkspaceBotoesNew
                label="Salvar Alteração"
                tipo="save"
                onClick={() => salvar()}
              />
            </div>
          )}
          {isNovo && (
            <WorkspaceBotoesNew
              label="Salvar Alteração"
              tipo="save"
              onClick={() => salvar()}
            />
          )}
        </BarraInferiorBotoes>
      </BoxConteudo>
    </WorkspaceFicha>
  );
};

export default FormVinculacaoUsuario;
